// eslint-disable-next-line import/prefer-default-export
export const FETCH_GOAL_BY_ID = 'fetchGoalById';
export const FETCH_GOALS_BY_USER_IDS = 'fetchGoalsByUserIds';
export const FETCH_GOALS_BY_USER_IDS_BY_DATES = 'fetchGoalsByUserIdsByDates';
export const CREATE_NEW_GOAL = 'createNewGoal';
export const UPDATE_GOAL = 'updateGoal';
